export default __webpack_public_path__ + "static/media/litho-demo-single-project-page-03.74d487c6.jpg";